import type { LockView } from "../types";

export interface LockState {
	/** The composer cannot send. */
	blocked: boolean;
	/** What to tell the person about the lock, or null when there is nothing to say. */
	note: string | null;
	/** Offer handing the lock back. */
	handBack: boolean;
}

/**
 * How a session's send lock shows in the composer. The server decides for real; this keeps a
 * person from typing a message that would only be refused.
 */
export function lockState(input: {
	lock: LockView | null | undefined;
	me: string;
	owner: string;
	shared: boolean;
	streaming: boolean;
	now: number;
	nameOf: (userId: string) => string;
}): LockState {
	const { lock, me, streaming, now } = input;
	const live = lock && (streaming || now < lock.idleExpiresAt) ? lock : null;
	if (!live) return { blocked: false, note: null, handBack: false };
	if (live.holder === me) return { blocked: false, note: null, handBack: input.shared };

	const who = input.nameOf(live.holder);
	if (streaming) return { blocked: true, note: me === input.owner ? `${who} 正在使用，本轮结束后可接管` : `${who} 正在使用`, handBack: false };
	if (me === input.owner) return { blocked: false, note: `${who} 正在使用，发送消息即可接管`, handBack: false };
	const minutes = Math.ceil((live.idleExpiresAt - now) / 60_000);
	return { blocked: true, note: `${who} 正在使用，约 ${minutes} 分钟后释放`, handBack: false };
}
